import * as React from 'react';

interface ToastData {
  variant: string;
  message: string;
  heading: string;
}

interface ToastContextType {
  toastData: ToastData | null;
  setToastData: (data: ToastData) => void;
}

const ToastContext = React.createContext<ToastContextType>({
  toastData: null,
  setToastData: () => {},
});

const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [toastData, setToastData] = React.useState<ToastData | null>(null);

  return <ToastContext.Provider value={{ toastData, setToastData }}>{children}</ToastContext.Provider>;
};

function useToast() {
  const context = React.useContext(ToastContext);
  return context;
}

export { ToastProvider, useToast };
